import React from 'react';
import FaqSection from '@React_UI_Lib/FaqSection';
import { STATIC_CAB_FAQ_PAGE } from '../../constants/templateConstants';

const FaqPage = ({ data }) => {
  return (
    <FaqSection
      showSearchInput={false}
      faqs={data.faqs}
      faqContainerStyle={styles.faqContainerStyle}
      questionTextStyle={styles.questionTextStyle}
      answerTextStyle={styles.answerTextStyle}
      faqQnActiveStyle={styles.faqQnActiveStyle}
      imgSrc={''}
    />
  );
};

FaqPage.fetchData = async () => {
  const cacheKey = 'HTML_STATIC_CABS_FAQS';

  const templateData = {
    templateName: STATIC_CAB_FAQ_PAGE,
    metaTitle: 'Cabs Booking FAQ',
    metaDescription: '',
    metaKeywords: '',
    analytics: ``,
    h1Title: 'FAQs',
    extraInfo: '',
    breadcrumb: [],
    faq: [],
    externalJs: '',
    sampleUrl: 'https://www.makemytrip.com/cabs/faqs',
    descriptionInHtml: ``
  };

  const faqs = [
    {
      question: 'How can I book cheap cabs online?',
      answer:
        'MakeMyTrip helps you with online cab booking at the best prices from various cab service providers. Also, you can use promo codes and offers on the MakeMyTrip website & app on online cab booking to get extra discounts.'
    },
    {
      question: 'What are the advantages of online taxi booking?',
      answer:
        'Online taxi booking not only helps you find the best prices from different service providers but also helps you with the convenience of paying through multiple payment options (like Debit Card, Credit Card, eWallets etc.). You can easily compare prices and choose various categories of cabs like Hatchback cars, Sedan and SUV.'
    },
    {
      question: 'Why should you book cabs from MakeMyTrip?',
      answer:
        'MakeMyTrip has a large number of service providers who list their cabs on MakeMyTrip thereby increasing your chances of obtaining the most competitive prices for your cabs. You also have the added advantage of access to MakeMyTrip’s customer care and an easy interface for booking with different payment modes with no hidden charges. While booking cabs online through MakeMyTrip, you can choose the car based on your requirement and preferences, depending on the cars available with the relevant service providers. You can book Hatchback like Indica, Swift, Sedan like Dzire, Etios and SUV like Innova, Ertiga.'
    },
    {
      question: 'What kind of cabs can you book from MakeMyTrip?',
      answer:
        'You can book the following kinds of cabs from MakeMyTrip: airport cabs and rentals / outstation cabs. You can book outstation cabs for both one-way transfers & round-trip transfers.'
    },
    {
      question: 'Do I need to register on MakeMyTrip to book a cab online?',
      answer:
        'No, you can successfully book the cab without registering on our website.'
    },
    {
      question: "What if the cab doesn't show up?",
      answer:
        'If the vehicle you booked does not arrive, we will immediately issue a complete refund.'
    },
    {
      question:
        'How is the total cab fare calculated for an intercity cab service?',
      answer:
        "For outstation trips (intercity), mostly X kms are included in fare. Route-wise charges will vary. Sometimes toll and state taxes might be included in the fare. In certain cases, these won't be part of the original fare, and the user would have to pay at trip end whatever extra charges are applicable. Extra charges can be waiting charges, extra KMs charges, extra hours charges, night charges, airport entry fee, airport parking charges, toll charges, state tax driver charges, parking charges, etc."
    },
    {
      question: 'Can I book a cab without credit/card or net banking option?',
      answer:
        'Yes, other payment options available are UPI (GPay, PhonePe), wallets (Paytm, Amazon Pay), and debit card.'
    },
    {
      question: 'What happens if the vehicle breaks down?',
      answer:
        "Since we work with established service providers, the vehicles are usually reliable. In case of a breakdown, it is the service provider's responsibility to replace the vehicle during the journey. In case of any persisting issue, you may reach out to the helpline number provided to you by MakeMyTrip, and we shall reach out to our vendor to arrange an alternate cab for you."
    },
    {
      question: 'How are the Kilometers calculated?',
      answer:
        "The 'Kilometers' are calculated based on the return trip distance between the boarding point and the destination."
    },
    {
      question:
        'How is the total cab fare/price calculated for a local cab service?',
      answer:
        'Four packages are available (4hrs & 40 kms, 8hrs & 80 kms, 12hrs & 120 kms, 24hrs & 300kms). Extra kms & extra hours charges applicable if usage exceeds the package taken.'
    },
    {
      question: 'What are the payment terms?',
      answer:
        'You can confirm your reservation by paying a small booking fee, typically up to 25% of the base fare. The balance can be paid directly to us through online modes until two days before the start of the journey or to the operator in cash at the time of completion of the trip.'
    },
    {
      question: 'What if I need to cancel my trip?',
      answer:
        'The cancellation policy is specific to each service provider and is listed against the quotes on the quotations page.'
    },
    {
      question: 'How are tolls & taxes calculated?',
      answer:
        "Tolls and interstate taxes are best estimates only. If these amounts are included in the fare, you'll be charged/reimbursed for any difference between the actuals and estimates, as applicable."
    }
  ];

  return {
    pushToCache: true, // if this is set then after ssr it will be stored in cache
    cacheKey,
    faqs,
    templateData: templateData
  };
};

export default FaqPage;

const styles = {
  faqContainerStyle: {
    padding: 10,
    maxHeight: '100%',
    overflow: 'scroll'
  },
  questionTextStyle: {
    fontSize: 16,
    fontFamily: 'lato',
    fontWeight: '400',
    padding: 2,
    marginLeft: 10
  },
  answerTextStyle: {
    fontSize: 14,
    paddingTop: 5,
    fontFamily: 'lato',
    fontWeight: '400',
    marginLeft: 10
  },
  faqQnActiveStyle: {
    fontSize: 16,
    fontWeight: 900,
    fontFamily: 'lato',
    marginLeft: 10,
    marginRight: 10
  }
};
